import {Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self, ViewChild} from '@angular/core';
import {MatFormFieldControl} from '@angular/material/form-field';
import {TdoInputComponent} from '../tdo-input/tdo-input.component';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import {noop, Subject} from 'rxjs';
import {formatCurrency, formatNumber} from '@angular/common';


@Component({
  selector: 'tdo-input',
  templateUrl: './tdo-input-v2.component.html',
  styleUrls: ['./tdo-input-v2.component.scss'],
  providers: [
    {provide: MatFormFieldControl, useExisting: TdoInputComponent},
    // {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MatFormFieldControl), multi: true}
  ]
})
export class TdoInputV2Component implements OnInit, OnDestroy, MatFormFieldControl<string>, ControlValueAccessor {
  @Input() widthString: string = '100%';
  @Input() placeholder: string = '';
  @Input() placeholderPosition: string = 'inline'; // inline / above
  @Input() isRequired: boolean = false;
  @Input() type: string;
  @Input() maskinput: string;
  @Input() restrictTo: string;
  @Input() isReadOnly: boolean = false;
  @Input() isCurrency: boolean = false;
  @Input() isHideUnderline: boolean = false;
  @Input() autocomplete: string = '';
  @Input() cypressControlIdentifier: string = 'ctrlTdoInput';

  // Overrides
  @Input() autofilled: boolean;
  @Input() controlType: string;
  @Input() disabled: boolean;
  @Input() empty: boolean;
  @Input() errorState: boolean;
  @Input() focused: boolean;
  @Input() id: string;
  @Input() required: boolean;
  @Input() shouldLabelFloat: boolean;
  @Input() userAriaDescribedBy: string;
  @Input() maxCharacters: number = -1;
  @Input() delayMs: number = 1000;

  @Output() inputFinished: EventEmitter<string> = new EventEmitter<string>();
  @Output() focusGained: EventEmitter<void> = new EventEmitter<void>();
  @Output() focusLost: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('input') inputElement: HTMLInputElement;

  phoneMask: any = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];    // USA
  // phoneMask: any = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,  /\d/, ' ', /\d/, /\d/, /\d/, /\d/];    // brasil landline
  // phoneMask: any = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,  /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];    // brasil mobil line

  datemask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];  // usa

  stateChanges = new Subject<void>();
  isInvalid: boolean = false;

  private innerValue: any = '';
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }



  }

  ngOnInit(): void {
    if (this.autocomplete === '') {
      const rand = Math.random() * 10000000;
      this.autocomplete = rand.toString();
    }

    if (this.type !== 'phone') {
      this.phoneMask = false;
    }

    if (!this.value) {
      this.value = '';
    }

    if(this.type==='email')
    {
      this.onEmailChanged(this.value);
    }

  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  onContainerClick(event: MouseEvent): void {
    //
  }

  setDescribedByIds(ids: string[]): void {
    //
  }

  get value(): any {
    return this.innerValue;
  }

  @Input()
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
      this.stateChanges.next();
      if (this.isCurrency) {
        this.innerValue = formatCurrency(v, 'en-US', 'USD', '1.0-2');
      }
    }
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onInputFinished(event: any) {

    if(this.type==='DOB') {
      let zd="";
      if (event) {
        zd = new Date(event).toLocaleDateString('en-US',  { // you can use undefined as first argument
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      }
      this.inputFinished.emit(zd);
      return;
    }

    this.inputFinished.emit(event);

  }

  onFocusGained(event: FocusEvent) {
    this.focusGained.emit();
  }

  onBlur(event: FocusEvent, input: HTMLInputElement) {
    this.focusLost.emit(input.value);
  }



  onEmailChanged(e: any) {
    if(e==="") {
      this.isInvalid = false;
      return ;
    }

    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    this.isInvalid = !regexp.test(e);
    this.value = e;
    this.inputFinished.emit(e);
  }
}
